<template>
    <!-- item.tipo_lanc == 'A' &&  -->
    <div class="form-row" v-if="fornecedor && fornecedor.adiantamentos && fornecedor.saldo_adiantamentos"> 
        <div class="col col-12">
            <div class="card mt-2 mb-0">
                <div class="card-header p-2 alert-info d-flex justify-content-between">
                    <a class="card-link" data-toggle="collapse" href="#detalheAdiantamentos">
                        <span class="small">Saldo de Adiantamentos: {{ $util.formatMoeda(fornecedor.saldo_adiantamentos) }}</span>
                    </a>
                    <div v-if="adiantamento_insuficiente">
                        <span data-toggle="tooltip" data-placement="top" :title="'Saldo adiantado insuficiente' + ( adiantamento ? ' para cancelamento' : '' )">
                            <i class="fa fa-exclamation-triangle" :class="adiantamento ? 'text-warning' : 'text-danger'" aria-hidden="true"></i>
                        </span>
                    </div>
                    <div v-else-if="edicao && fornecedor && fornecedor.saldo_adiantamentos > 0" class="mr-2">
                        <a href="#" @click.prevent="utilizar_saldo()" data-toggle="tooltip" data-placement="top" title="Utilizar Saldo">
                            <i class="fas fa-arrow-circle-down"></i>
                        </a>
                    </div>
                </div>
                <div class="collapse" id="detalheAdiantamentos">
                    <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between" v-for="(ad, iad) in fornecedor.adiantamentos" :key="iad">
                            <div class="small">
                                {{ $util.getFormatDate(ad.baixa ? ad.baixa.dt_baixa : ad.dt_emissao) }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                #{{ ad.id_lancamento }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ ad.st_descricao }}
                            </div>
                            <div>
                                {{ $util.formatMoeda( ( ad.baixa && ad.ch_tipo_lancamento == 'M' ) ? ad.baixa.valor_liquido : ( ad.baixa_adiantamento ? ad.baixa_adiantamento.valor_liquido : 0 ) ) }}
                                <i class="fa fa-plus-circle text-success ml-2" v-if="ad.ch_tipo_lancamento == 'M'"></i>
                                <i class="fa fa-minus-circle text-danger ml-2" v-if="ad.ch_tipo_lancamento == 'D'"></i>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
    props: ['fornecedor', 'valor', 'adiantamento', 'edicao'], 

    computed: { 
        adiantamento_insuficiente() { 
            if ( !this.fornecedor )
                return false;

            return ( Math.round(this.valor * 100) > Math.round(this.fornecedor.saldo_adiantamentos * 100) ); 
        },
    },

    methods: { 
        utilizar_saldo() { 
            this.$emit('usar', this.fornecedor.saldo_adiantamentos);
        }
    }

}
</script>